import { AlternateInvestmentStatus } from 'types';
import i18n from '../../i18n';
import { humanReadableString } from '../../utils/stringUtils';

const STATUS_LABELS: Partial<Record<AlternateInvestmentStatus, string>> = {
  [AlternateInvestmentStatus.READY_FOR_CONFIGURATION]: i18n.t('pb.products.status.readyforconfiguration'),
  [AlternateInvestmentStatus.INACTIVE]: i18n.t('pb.products.status.inactive'),
};

/**
 * The label a user sees for an agreement status: the status pill, the Status column filter and the
 * revision history must all use it so the same status never reads two different ways.
 */
export function getStatusLabel(status: string | undefined | null): string {
  if (!status) return '';

  return STATUS_LABELS[status as AlternateInvestmentStatus] ?? humanReadableString(status);
}
